import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer mt-auto py-4 bg-light border-top">
            <Container>
                <Row className="align-items-center">
                    <Col md={6}>
                        <p className="mb-0 text-muted">
                            © {currentYear} Press Forward Mail. All rights reserved.
                        </p>
                    </Col>
                    <Col md={6} className="text-md-end">
                        <Link to="/privacy" className="text-muted me-3 text-decoration-none">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="text-muted text-decoration-none">
                            Terms of Use
                        </Link>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;